import { ReactComponent as CommunicationImage } from "assets/icons/communicationSuccessImage.svg";
import React from "react";
import { useDispatch } from "react-redux";
import { setCampaignEditData, setCardContent } from "services/api/communication";
import { Footer } from "../Footer/Footer";
import {
  CommunicationImageWrapper,
  SummaryDetails,
  Text,
  Title,
  Wrapper,
} from "./Theme";
export const CreatedCampaignDone = ({
  details,
  text,
  setCampaignModal,
 setToggle
}) => {
  const dispatch = useDispatch()

  const buttons = [
    {
      name: "Done",
      action: () => {
        setCampaignModal()
        setToggle("Campaigns")
        dispatch(setCardContent(""));
        dispatch(setCampaignEditData({}));
      },
      isDisabled: false,
      type: "primary",
      width: "100px",
      variant : "primary"

    },
  ];
  return (
    <Wrapper>
      <CommunicationImageWrapper>
        <CommunicationImage />
      </CommunicationImageWrapper>
      <Title>
        <Text>{text}</Text>
      </Title>
      <SummaryDetails>
        <ul>
          {details?.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      </SummaryDetails>
      <hr />
      <br />
      <Footer buttons={buttons} type="My template" />
    </Wrapper>
  );
};
